module.exports = __webpack_public_path__ + "img/illustrate03.793b1215.png";